import React from "react";

const CircularSpinner = () => (
  <div className="flex justify-center items-center w-screen h-screen">
    <div className="border-t-4 border-brand-gold border-solid w-28 h-28 rounded-full animate-spin"></div>
  </div>
);

export default CircularSpinner;
